export default __webpack_public_path__ + "static/media/morocco5.d06970d5.jpg";